<script>
import blockies from "blockies"

export default {
  functional: true,

  props: {
    input: {
      type: String,
      required: true
    },
    square: Boolean,
    options: {
      type: Object
    }
  },

  render(create, { props, data }) {
    const avatar = blockies({
      ...props.options,
      seed: props.input
    })
    const classList = ["mtx-blockie", data.staticClass]
    if (!props.square) {
      classList.push("mtx-blockie--round")
    }

    return create("img", {
      class: classList,
      attrs: {
        ...data.attrs,
        src: avatar.toDataURL(),
        alt: data.attrs.alt || props.input
      }
    })
  }
}
</script>

<style>
.mtx-blockie--round {
  border-radius: 50%;
}
</style>
